import React from 'react'
import Tr from 'translations/Translations';
import ShareIcon from '@material-ui/icons/Share'
import PropTypes from "prop-types";
import WorkableIconButton from "./WorkableIconButton";

function WorkableIconShareButton(
    {
        tooltip = Tr("send"),
        ...props
    }) {

    return <WorkableIconButton
        tooltip={tooltip}
        Icon={ShareIcon}
        {...props}
    />
}

WorkableIconShareButton.propTypes = {
    working: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.elementType]),
    hideTooltip: PropTypes.bool,
    color: PropTypes.string,
    onClick: PropTypes.func
}

export default WorkableIconShareButton;